import { useAuth } from "../context/authContext";
import { checkAuthAdminApi } from "../api/authApi";
import { useQuery } from "@tanstack/react-query";

export const useCheckAuth = () => {
  const { setUser, setAuthChecked } = useAuth();

  return useQuery({
    queryKey: ["check-admin-auth"],
    queryFn: async () => {
      const res = await checkAuthAdminApi();
      return res; // success
    },

    retry: false,
    refetchOnWindowFocus: false, // 🔴 auth ke liye important
    staleTime: Infinity,         // 🔴 once per load

    onSuccess: (data) => {
      if (data?.user) {
        setUser(data.user);
      } else {
        setUser(null);
      }
      setAuthChecked(true);
    },

    onError: () => {
      setUser(null);
      setAuthChecked(true);
    },
  });
};